import React from 'react';
import {
  actions as mainActions,
  SONDA_KIND,
} from '@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer-r';
import Button from '@gcloud-npm/next12.components.button-n';
import { put } from 'redux-saga/effects';

import { LAYOUT_NAMES } from './helper';

export const GetMockData = (path) => {
  let mockData = null;
  const PUBLIC_URLS_NAMES_KEYS = Object.keys(LAYOUT_NAMES);
  PUBLIC_URLS_NAMES_KEYS.forEach((publicKey) => {
    if (LAYOUT_NAMES[publicKey].id === path) {
      mockData = LAYOUT_NAMES[publicKey].mock;
    }
  });
  return mockData;
};

export function* ThrowSonda({ filePath, processName, error }) {
  yield put(
    mainActions.throwSonda({
      error,
      filePath,
      kind: SONDA_KIND.ERROR,
      processName,
    })
  );
}
export const SendSondaComponentNotShown = (componentName, dispatch) => {
  const error = `Componente ${componentName} con datos no válidos. No se muestra el componente ${componentName}`;
  dispatch(
    mainActions.throwSonda({
      error,
      filePath: `components/${componentName}`,
      kind: SONDA_KIND.ERROR,
      processName: componentName,
    })
  );
};

/* eslint-disable prefer-destructuring */
export const GetButton = (cta, customClickEvent, btnTaggingInfo) => {
  // Obtención del boton con evento o con enlace
  const showButtonWithLink = cta && cta.urlButton;
  const showButtonWithEvent = customClickEvent;
  let button = <div />;

  if (showButtonWithLink) {
    button = (
      <Button
        label={cta.btnText}
        taggingInfo={btnTaggingInfo}
        href={cta.urlButton}
      />
    );
  } else if (showButtonWithEvent) {
    button = (
      <Button
        label={cta.btnText}
        taggingInfo={btnTaggingInfo}
        onClick={
          cta.idPlan ? () => customClickEvent(cta.idPlan) : customClickEvent
        }
      />
    );
  }
  return button;
};
